(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('DispositivoDeleteController',DispositivoDeleteController);

    DispositivoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dispositivo'];

    function DispositivoDeleteController($uibModalInstance, entity, Dispositivo) {
        var vm = this;

        vm.dispositivo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dispositivo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
